import SpriteFrameHolder from "../../../../public/ui/spriteFrameHolder";
import { ListViewDir, ListView } from "../../../../../framework/tools/scrollview/listview";
import AppData from "../../../../public/const/app_data";


const {ccclass, property} = cc._decorator;

@ccclass
export default class ItemMap extends cc.Component {
    @property(cc.Node)
    prefab: cc.Node[] = [];

    @property(cc.SpriteFrame)
    bgList : cc.SpriteFrame[] = [];

    @property(SpriteFrameHolder)
    iconSprFrameHolder_YXX:SpriteFrameHolder = null
  
    @property(SpriteFrameHolder)
    iconSprFrameHolder_TB:SpriteFrameHolder = null
   
    @property(SpriteFrameHolder)
    iconSprFrameHolder_CP:SpriteFrameHolder = null
    @property(cc.Node)
    view: cc.Node = null;
    @property(cc.ScrollView)
    scrollview: cc.ScrollView = null;
    @property(cc.Node)
    content: cc.Node = null;
    @property(cc.Node)
    poolNode:cc.Node = null;


    listView: ListView;
    dataList:any[] = []

 

    createItems : cc.Node[] = [];
    appearCount:number[] = [0,0,0,0,0,0]
    // LIFE-CYCLE CALLBACKS:
    onLoad()
    {        
        let bg_sprite = this.getComponent(cc.Sprite);
        if (bg_sprite) {
            bg_sprite.spriteFrame = AppData.gameSimpleName == "CP" ? this.bgList[1] : this.bgList[0];
        }
    }
    LoadItem() {

        console.log(" itemMap loadItem ..");
        // if (this.listView) {            
        //     this.listView.destroyListView();
        // }

        if (!this.listView) {
         
            let list: ListView = new ListView({
                scrollview: this.scrollview,
                view: this.view,
                content: this.content,
                item_prefab: AppData.gameSimpleName == "CP"? this.prefab[1] : this.prefab[0],
                cb_host: this,
                item_update_func: (AppData.gameSimpleName == "CP" ? this.update_list_item_cp : this.update_list_item_normal),
                select_cb: this.on_item_select,
                column: 1,
                row: 1,
                gap_y: 10,
                gap_x: 13.2,
                direction:  ListViewDir.Horizontal,
            });
            this.listView = list
        }
        
    }

    onDisable(){

        this.createItems.forEach((item)=>{
            if (item && item.isValid) {
                item.stopAllActions();
                item.active = false;   
            }                     
        })


        //这里把可能关闭的item给打开
        if(this.listView && this.listView.items){

            this.listView.items.forEach((item)=>{
                if (item.node && item.node.isValid) {
                    item.node.active = true;   
                }                
            });
        }
        
    }

    
    on_item_select(data: any, index: number) {
        //cc.log(data, index);
    }
    updateShow(reposeList:any[] = null){

        
        if (reposeList == null) return 
               
         //取最近21个.. 多取一个
        let different = false;
        let reverse_list = reposeList.reverse().filter((value,index)=>{ return index < 21});

        if (this.dataList.length == 0) {            
            different = true;
        }else{
           
            for (let index = 0; index < reverse_list.length; index++) {
                const data = reverse_list[index];
                if (this.dataList[index] != data) {
                    different = true;
                    break;
                }
            }
        }


        console.log(" itemMap updateShow different " , different);
        
        if (different) {
            
            reverse_list.forEach( (data,index) => {
            
                let createItem = this.createItems[index] ;
                if (createItem) {
                    createItem.active = false;
                    createItem.stopAllActions();
                }
            });
            
            this.listView.set_data( reverse_list );
            this.dataList = reverse_list;

            
        }

    }

    //拆出一局开出的结果  服务器给的值如“123” 表示这一局开出的结果为  1， 2, 3
    disposeData(data){
        let ret:number[] =[]
        let dataString = String(data)
        ret[0] = Number(dataString[0])
        ret[1] = Number(dataString[1])
        ret[2] = Number(dataString[2])
        return ret
    }
   
    update_list_item_normal(item: cc.Node, data: any, index: number)
    {
        let spriteHolder = AppData.gameName == "TM_TB" ? this.iconSprFrameHolder_TB : this.iconSprFrameHolder_YXX;

        let datas = this.disposeData(data)

        for (let index = 0; index < 3; index++) {

            let instance_icon = cc.find("icon" + (index + 1), item).getComponent(cc.Sprite)                
            instance_icon.spriteFrame = spriteHolder.getSpriteFrameByKey(datas[index]+"" );        
        }

        let createItem = this.moveAction(item,data,index,65);
        if (createItem) {
  
            for (let index = 0; index < 3; index++) {

                let instance_icon = cc.find("icon" + (index + 1), createItem).getComponent(cc.Sprite)                
                instance_icon.spriteFrame = spriteHolder.getSpriteFrameByKey(datas[index]+"" );        
            }
        } 
    }

    update_list_item_cp(item: cc.Node, data: any, index: number)
    {
        let icon = cc.find("icon", item).getComponent(cc.Sprite)
        let sprite = this.iconSprFrameHolder_CP.getSpriteFrameByKey(data);
        icon.spriteFrame = sprite;

        let createItem = this.moveAction(item,data,index,94.4);
        if (createItem) {
            
            let instance_icon1 = cc.find("icon", createItem).getComponent(cc.Sprite)
            instance_icon1.spriteFrame = sprite;   
        }
    
    }

    private moveAction(item: cc.Node, data: any, index: number,offset : number) : cc.Node{

        if (this.dataList.length == 0) {
                     
            //此时dataList没有数据 表示第一次进 不需要移动表现 
            item.active = true; 
            return null;
        }

        let prefab = AppData.gameName == "TM_CP" ? this.prefab[1] : this.prefab[0];

        let offset_x = offset;

        let createItem = this.createItems[index] ;

        if (!createItem) {
            createItem = cc.instantiate(prefab);   
            createItem.name += "_copy"
            this.createItems[index] = createItem;

        }else{
            //有可能动作没有结束 
            createItem.stopAllActions();
        }

        createItem.parent = this.content;
        createItem.setPosition(new cc.Vec2(item.position.x - offset_x,item.position.y));
        createItem.active = true;
        item.active = false;     

        //做一个偏移的动画
        let action = cc.moveBy(0.8,new cc.Vec2(offset_x,0));
        createItem.runAction(cc.sequence(action,cc.callFunc(()=>{

            item.active = true;
            createItem.active = false;       
            
        }))); 

        return createItem;
    }

}
